import React, { FunctionComponent } from 'react';

/**
 * Hourglass Empty Icon
 */
const HourglassEmptyIcon: FunctionComponent<React.PropsWithChildren<{ color?: string }>> = ({
  color = 'white'
}) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 1.3335V5.3335H4.00667L4 5.34016L6.66667 8.00016L4 10.6668L4.00667 10.6735H4V14.6668H12V10.6735H11.9933L12 10.6668L9.33333 8.00016L12 5.34016L11.9933 5.3335H12V1.3335H4ZM10.6667 11.0002V13.3335H5.33333V11.0002L8 8.3335L10.6667 11.0002ZM5.33333 5.00016L8 7.66683L10.6667 5.00016V2.66683H5.33333V5.00016Z"
        fill={color === 'red' ? '#DC4F4F' : color}
      />
    </svg>
  );
};

export default HourglassEmptyIcon;
